import { CustomBoxV2 } from "components";
import { BatterIcon } from "pages/internal-dashboard/icons";

export function Batter({ data, loading, percentages }: any) {
  return (
    <CustomBoxV2
      loading={loading}
      color="#E1E3E8"
      title="Batter"
      userCount={data?.total || 0}
      boxData={{
        label: "Batter",

        todayCount: data?.day || 0,
        weekCount: data?.week || 0,
        monthCount: data?.month || 0,
        yearCount: data?.year || 0,
        icon: BatterIcon,
      }}
      percentages={percentages}
    />
  );
}
